import MergeIcon from "@mui/icons-material/Merge";
import CompressIcon from "@mui/icons-material/Compress";
import ImageIcon from "@mui/icons-material/Image";
import EditIcon from "@mui/icons-material/Edit";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import ViewKanbanIcon from "@mui/icons-material/ViewKanban";
import {CodeIcon} from "lucide-react";
import FavoriteIcon from "@mui/icons-material/Favorite";

export const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 B";
    const k = 1024;
    const sizes = ["B", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Number.parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

export const PdfQuality = Object.freeze({
    LOW: "LOW",
    MEDIUM: "MEDIUM",
    HIGH: "HIGH",
});

// Single source of truth for tools — sidebar, dashboard, and routing all read from here.
export const TOOLS = [
    {
        id: "image-to-pdf",
        label: "Image → PDF",
        path: "/image-to-pdf",
        icon: ImageIcon,
        description: "Convert PNG, JPG, WEBP into a clean PDF document.",
        accent: "#FF5A4E",
    },
    {
        id: "pdf-merge",
        label: "Merge PDFs",
        path: "/merge",
        icon: MergeIcon,
        description: "Combine multiple PDFs into a single document.",
        accent: "#2563EB",
    },
    {
        id: "pdf-compress",
        label: "Compress PDF",
        path: "/compress",
        icon: CompressIcon,
        description: "Reduce PDF file size with adjustable quality.",
        accent: "#0F9D58",
    },
    {
        id: "pdf-edit",
        label: "Edit PDF",
        path: "/edit",
        icon: EditIcon,
        description: "Annotate, reorder, and remove pages from PDFs.",
        accent: "#F59E0B",
    },
];

// ── Donations ───────────────────────────────────────────────────────────────
// Single source of truth for all donation methods. Adding a new payment
// provider later (Stripe, Buy Me a Coffee, crypto) → add an entry here and
// the donated page will pick it up automatically.
export const DONATIONS = {
    // Suggested amounts (EUR) — used on the donated page buttons
    suggestedAmounts: [3, 5, 10, 25, 50],
    defaultAmount: 5,
    currency: "EUR",

    // Active payment providers
    methods: [
        {
            id: "paypal",
            label: "PayPal",
            // ⚠️ Personal account for now. Will switch to business account later.
            // Format: just the email address registered with PayPal.
            recipient: "lilnobp2@yahoo.ca",
            // PayPal builds a checkout URL from email + amount + currency.
            // No client secrets are needed — anyone can pay with just the recipient email.
            buildUrl: (amount, currency, note) => {
                const base = "https://www.paypal.com/donate";
                const params = new URLSearchParams({
                    business: "lilnobp2@yahoo.ca",
                    currency_code: currency || "EUR",
                    amount: String(amount || ""),
                    item_name: note || "KM-BIZZ PDF Tools donation",
                });
                return `${base}?${params.toString()}`;
            },
            description: "Fastest way. Pay with PayPal balance, card, or bank.",
            badge: "RECOMMENDED",
        },
        // Future: add Stripe, Buy Me a Coffee, crypto, etc. here
        // Example shape (commented out until ready):
        // {
        //     id: "stripe",
        //     label: "Card via Stripe",
        //     buildUrl: (amount) => `https://buy.stripe.com/xyz?amount=${amount * 100}`,
        //     description: "Credit/debit card. No PayPal account needed.",
        // },
    ],
};
export const NAV_SECONDARY = [
    { id: "dashboard", label: "Dashboard", path: "/", icon: DashboardIcon },
    { id: "feedback", label: "Feedback", path: "/feedback", icon: ChatBubbleOutlineIcon },
    { id: "kanban", label: "Kanban Board", path: "/kanban", icon: ViewKanbanIcon },
    { id: "api", label: "API Reference", path: "/api-docs", icon: CodeIcon },
    { id: "donate", label: "Support / Donate", path: "/donate", icon: FavoriteIcon },
];

export const API_BASE = ""; // proxied through dev server / nginx
export const EDITOR_API = "/editor-api";